import React from 'react'
import { useTranslation } from 'react-i18next'

import { getAppConfigMap } from 'helpers/getAppConfigMap'

import closeIcon from 'assets/images/close-icon.svg'

import { COOKIE_CONSENT_CATEGORIES } from '../../constants'
import { CookieConsentCategory } from './CookieConsentCategory'
import { StyledCookieConsentPreferences as S } from './CookieConsentPreferences.styles'

type TCookieConsentPreferencesProps = {
  normalizedConsentTypes: string[]
  onAcceptAll: () => void
  onClose: () => void
  onConfirmChoices: () => void
  onRejectAll: () => void
  onToggleCategory: (categoryKey: string) => void
}

export const CookieConsentPreferences: React.FC<
  TCookieConsentPreferencesProps
> = ({
  normalizedConsentTypes,
  onAcceptAll,
  onClose,
  onConfirmChoices,
  onRejectAll,
  onToggleCategory,
}) => {
  const { t } = useTranslation()
  const { appConfig } = getAppConfigMap()

  return (
    <S.PreferencesViewport>
      <S.PreferencesPanel>
        <S.BrandHeader>
          <S.BrandBar>{appConfig.displayName}</S.BrandBar>

          <S.BrandClose type="button" onClick={onClose}>
            <img src={closeIcon} width={24} height={24} alt="Close" />
          </S.BrandClose>
        </S.BrandHeader>

        <S.PreferencesHeader>
          <S.HeaderRow>
            <S.PreferencesTitle>
              {t('cookieConsent.privacyCenter.title')}
            </S.PreferencesTitle>

            <S.HeaderClose type="button" onClick={onClose}>
              <img src={closeIcon} width={24} height={24} alt="Close" />
            </S.HeaderClose>
          </S.HeaderRow>
        </S.PreferencesHeader>

        <S.ScrollArea>
          <S.ContentColumn>
            <S.IntroBlock>
              <S.PreferencesText>
                {t('cookieConsent.privacyCenter.subtitle')}
              </S.PreferencesText>
            </S.IntroBlock>

            <S.PrimaryButton type="button" onClick={onAcceptAll}>
              {t('actions.allowAll')}
            </S.PrimaryButton>

            <S.SectionTitle>
              {t('cookieConsent.manageConsentPreferences')}
            </S.SectionTitle>

            <S.CategoryList>
              {COOKIE_CONSENT_CATEGORIES.map((category) => (
                <CookieConsentCategory
                  key={category.key}
                  category={category}
                  normalizedConsentTypes={normalizedConsentTypes}
                  onToggleCategory={onToggleCategory}
                />
              ))}
            </S.CategoryList>
          </S.ContentColumn>
        </S.ScrollArea>

        <S.PreferencesFooter>
          <S.ActionRow>
            <S.PrimaryButton type="button" onClick={onAcceptAll}>
              {t('actions.allowAll')}
            </S.PrimaryButton>

            <S.SecondaryButton type="button" onClick={onConfirmChoices}>
              {t('actions.confirmMyChoices')}
            </S.SecondaryButton>

            <S.SecondaryButton type="button" onClick={onRejectAll}>
              {t('actions.rejectAll')}
            </S.SecondaryButton>
          </S.ActionRow>
        </S.PreferencesFooter>
      </S.PreferencesPanel>
    </S.PreferencesViewport>
  )
}
